import { render, staticRenderFns } from "./collection-sidebar.vue?vue&type=template&id=7033ed36&xmlns%3Av-swiper=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml&"
import script from "./collection-sidebar.vue?vue&type=script&lang=js&"
export * from "./collection-sidebar.vue?vue&type=script&lang=js&"
import style0 from "./collection-sidebar.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports